import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Typography } from "../../../../Components";
function MeasurementKg({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  setFieldValue,
}) {
  return (
    <div>
      {" "}
      <Row className="d-flex justify-start   px-3">
        <Col md={4} className="p-0 ">
          <Typography fontSize="1.15rem" fontWeight="400" className="my-3">
            Weight (kg)
          </Typography>
          <Form.Control
            required
            type="text"
            backgroundColor="#EBEBFF"
            name="weightKg"
            placeholder="e.g. 68"
            className="w-100 fs-6"
            value={values?.weightKg}
            onChange={handleChange}
            onBlur={handleBlur}
            isInvalid={touched.weightKg && !!errors.weightKg}
            size="lg"
            autoFocus
          />
          <Form.Control.Feedback type="invalid">
            {errors.weightKg}
          </Form.Control.Feedback>
        </Col>
      </Row>
      <Row className="d-flex justify-start  px-3">
        <Col md={4} className="p-0 ">
          <Typography fontSize="1.15rem" fontWeight="400" className="my-3">
            Height (cm)
          </Typography>
          <Form.Control
            required
            type="text"
            backgroundColor="#EBEBFF"
            name="heightCm"
            placeholder="e.g. 170"
            className="w-100 fs-6"
            value={values?.heightCm}
            onChange={handleChange}
            onBlur={handleBlur}
            isInvalid={touched.heightCm && !!errors.heightCm}
            size="lg"
            autoFocus
          />
          <Form.Control.Feedback type="invalid">
            {errors.heightCm}
          </Form.Control.Feedback>
        </Col>
      </Row>
    </div>
  );
}

export default MeasurementKg;
